<template>
  <!-- 代理管理-发票管理 -->
  <div class="firm-body">
    <div class="title-Individual-center">
      <span class="firm-clickable" @click="handelBack">企业中心</span
      ><i class="el-icon-arrow-right"></i
      ><span class="firm-clickable" @click="handelBack">代理服务</span
      ><i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">发票管理</span>
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <div class="Above-Button">
        <div class="Toggle">
          <div
            v-for="(item, index) in selectArr"
            :key="index"
            class="tab-item"
            :class="Toggle == item.id ? 'select-tab' : ''"
            @click="handelSelect(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="main-body-box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectArr: [
        {
          name: "已开出",
          id: "1",
          url: "/Invoice/issue",
        },
        {
          name: "已开入",
          id: "2",
          url: "/Invoice/Enter",
        },
      ],
      Toggle: "1",
    };
  },
  watch: {
    $route() {
      if (this.$route.path == "/Invoice/issue") {
        this.Toggle = "1";
      } else if (this.$route.path == "/Invoice/Enter") {
        this.Toggle = "2";
      }
    },
  },
  components: {},
  created() {},
  mounted() {
    let currentUrl = this.$route.path;
    if (currentUrl == "/Invoice/issue") {
      this.Toggle = "1";
    } else if (currentUrl == "/Invoice/Enter") {
      this.Toggle = "2";
    }
  },
  destroyed() {},
  methods: {
    handelSelect(num) {
      this.Toggle = num.id;
      this.$router.push({
        path: num.url,
      });
    },
    handelBack() {
      this.$router.push({
        path: "/Choice",
      });
    },
  },
};
</script>

<style scoped lang="less">
.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  .firm-Content-subject {
    width: 100%;
    min-height: 720px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    padding: 30px;
    .Above-Button {
      width: 100%;
      height: 35px;
      display: flex;
      position: relative;
      .Toggle {
        width: 50%;
        height: 30px;
        display: flex;
        text-align: center;
        font-weight: 400;
        margin-top: 5px;
        .tab-item:nth-child(1) {
          margin-left: 20px;
        }
        .tab-item {
          margin-right: 100px;
          font-size: 16px;
          cursor: pointer;
          color: #333333;
        }
        .select-tab {
          color: #409eff;
          box-sizing: border-box;
          border-bottom: 3px solid #409eff;
        }
      }
    }

    .main-body-box {
      width: 100%;
      min-height: 100px;
      margin-top: 30px;
    }
  }
}
</style>
